let freeGiftPromoConfig = { name: "Free Promo", qualifying_spend: 10000, free_product_variant_id: 47920296394984 };


class FreeGiftPromoCalculator {
  constructor(name, lineItems, qualifyingSpend, freeVariantID) {
    this.name = name;
    this.lineItems = lineItems;
    this.qualifyingSpend = qualifyingSpend;
    this.freeVariantID = freeVariantID;
  }

  eligible() {
    return this.totalSpend() >= this.qualifyingSpend;
  }

  totalSpend() {
    return this.lineItems.reduce((tally, lineItem) => lineItem.total + tally, 0);
  }

  freeGiftInCart() {
    return !!this.lineItems.find(lineItem => lineItem.variantID == this.freeVariantID);
  }
}


class FreeGiftPromo extends HTMLElement {
  constructor() {
    super();
    this.config = freeGiftPromoConfig;
  }

  connectedCallback() {
    // create a global singleton that can easily be referenced
    window.freeGiftPromo = this;
    this.process();
  }

  addFreeGiftToCart() {
    let requestConfig = {
      method: "POST",
      headers: { "Content-Type": 'application/json', Accept: 'application/javascript', "X-Requested-With": "XMLHttpRequest" },

      body: JSON.stringify({ items: [{ quantity: 1, id: this.config.free_product_variant_id }] })
    }
    this.sendRequest("/cart/add.js", requestConfig);
  }

  removeFreeGiftFromCart() {
    let updates = {}
    updates[this.config.free_product_variant_id] = 0;

    let requestConfig = {
      method: "POST",
      headers: { "Content-Type": 'application/json', Accept: 'application/javascript', "X-Requested-With": "XMLHttpRequest" },

      body: JSON.stringify({ updates: updates })
    }
    this.sendRequest("/cart/update.js", requestConfig);
  }

  sendRequest(url, config) {
    fetch(url, config)
      .then((response) => response.json())
      .then((response) => {
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        location.reload();
      });
  }

  process() {
    let calc = new FreeGiftPromoCalculator(this.config.name, this.lineItems, this.config.qualifying_spend, this.config.free_product_variant_id)
    let eligible = calc.eligible();
    let freeGiftInCart = calc.freeGiftInCart();
    let availableQty = this.availableFreeGiftQty;

    console.log(`[Eligible spend met: ${eligible}, gift in cart: ${freeGiftInCart}, freeGiftQtyAvailable: ${availableQty}]`);
    if (eligible && availableQty && !freeGiftInCart) {
      this.addFreeGiftToCart();
    }

    if (freeGiftInCart && !eligible) {
      this.removeFreeGiftFromCart();
    }

  }

  get lineItems() {
    return Array.from(this.querySelectorAll('line-item')).map((el) => {
      return {
        variantID: Number(el.getAttribute('variant-id')),
        quantity: Number(el.getAttribute('quantity')),
        line: Number(el.getAttribute('line')),
        total: Number(el.getAttribute('total'))
      }
    })
  }

  set lineItems(lineItems) {
    let children = lineItems.map((item, idx) => {
      let el = document.createElement('line-item');
      el.setAttribute('variant-id', item.id);
      el.setAttribute('quantity', item.quantity);
      el.setAttribute('line', idx + 1);

      return el;
    });

    this.replaceChildren(...children);
  }

  get availableFreeGiftQty() {
    return Number(this.getAttribute("free-gift-available-qty"));
  }
}

customElements.define('free-gift-promo', FreeGiftPromo);
